import Swiper from 'swiper';
import { A11y, Pagination } from 'swiper/modules';

export default () => ({
    swiper: null,
    init() {
        this.$nextTick(() => this.setup());
    },
    setup() {
        if (!this.$refs.swiper) {
            return;
        }

        this.swiper = new Swiper(this.$refs.swiper, {
            modules: [A11y, Pagination],
            grabCursor: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            centeredSlidesBounds: true,
            spaceBetween: 20,
            watchSlidesProgress: true,
            a11y: {
                nextSlideMessage: 'Další složka',
                prevSlideMessage: 'Předchozí složka',
            },
            pagination: {
                el: this.$refs.pagination,
                clickable: true,
                bulletClass: 'ingredients__carousel__pagination__bullet',
                bulletActiveClass: 'ingredients__carousel__pagination__bullet--active',
                renderBullet: (index, className) => (
                    `<button class="${className}" type="button" aria-label="Přejít na složku ${index + 1}"></button>`
                ),
            },
        });
    },
    destroy() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    },
});
